/**
 * Check if the current window width is at or below
 * a certain _breakpoint_ size.
 * @param {string} breakpoint one of xs|sm|md|lg|xl
 * @return {bool} matches
 */
export const matchBreakpoint = (breakpoint) => {
	const breakpoints = {
		xs: 576,
		sm: 768,
		md: 992,
		lg: 1200,
		xl: null,
	};

	const pixels = breakpoints[breakpoint];
	if (undefined === pixels || null === pixels) {
		return true;
	}

	const breakpointMediaQuery = window.matchMedia(`(max-width: ${pixels}px)`);

	return breakpointMediaQuery.matches;
};
